/**
 * Reusable "presented by" sponsorship slot used in the sales demo.
 * It shows a sellable placement WITHOUT naming a real brand, and is
 * clearly badged as a sample so it is never mistaken for a real deal.
 */
export default function SponsorSlot({
  label = 'Presented by',
  tone = 'light',
  note = 'Sample placement',
}: {
  label?: string;
  tone?: 'light' | 'dark';
  note?: string;
}) {
  const isDark = tone === 'dark';

  return (
    <div
      className={
        isDark
          ? 'inline-flex items-center gap-3 bg-foreground-900 border border-foreground-800 rounded-lg pl-2 pr-3 py-2'
          : 'inline-flex items-center gap-3 bg-background-100 border border-background-200 rounded-lg pl-2 pr-3 py-2'
      }
    >
      <span
        className={
          isDark
            ? 'w-10 h-10 flex items-center justify-center rounded-md bg-foreground-800 text-accent-400'
            : 'w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700'
        }
      >
        <i className="ri-award-line text-xl"></i>
      </span>
      <span className="flex flex-col leading-tight">
        <span
          className={
            isDark
              ? 'font-label uppercase tracking-[0.24em] text-[10px] text-foreground-400 font-semibold'
              : 'font-label uppercase tracking-[0.24em] text-[10px] text-foreground-500 font-semibold'
          }
        >
          {label}
        </span>
        <span className={isDark ? 'font-heading font-bold text-base text-background-50' : 'font-heading font-bold text-base text-foreground-950'}>
          Your Brand Here
        </span>
      </span>
      <span
        className={
          isDark
            ? 'font-label font-bold uppercase tracking-widest text-[9px] px-2 py-1 rounded-sm bg-foreground-800 text-accent-400 whitespace-nowrap'
            : 'font-label font-bold uppercase tracking-widest text-[9px] px-2 py-1 rounded-sm bg-secondary-100 text-secondary-900 whitespace-nowrap'
        }
      >
        {note}
      </span>
    </div>
  );
}